import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=3f02e0ce&scoped=true&"
import script from "./welcome.vue?vue&type=script&lang=ts&"
export * from "./welcome.vue?vue&type=script&lang=ts&"
import style0 from "./welcome.vue?vue&type=style&index=0&id=3f02e0ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f02e0ce",
  null
  
)

export default component.exports